export type EstablishSessionCode =
  | 'transport-error'
  | 'no-response'
  | 'token-rejected'
  | 'timeout'
  | 'server-error'
  | 'malformed-payload';

/** Error thrown when a session could not be established. `code` is the queryable reason; `status` is the HTTP status when one was received. */
export default class EstablishSessionError extends Error {
  code: EstablishSessionCode;

  status?: number;

  constructor(code: EstablishSessionCode, options?: ErrorOptions & { status?: number }) {
    super(code);
    this.name = 'EstablishSessionError';
    this.code = code;
    this.status = options?.status;
    // Hermes doesn't reliably honor the Error(message, { cause }) option, so assign explicitly.
    if (options?.cause !== undefined) this.cause = options.cause;
  }
}
